module.exports = "../../fonts/vendor/@mdi/materialdesignicons-webfont.woff?059ea00c378aeafc39fc680ecc5ef66b";